import React, { useEffect } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { observer } from 'mobx-react';
import { PrivateRoute } from './components/routes';
import { NotFoundPage } from './pages/NotFoundPage/NotFoundPage';
import { SignUpPage } from './pages/SignupPage/Signup';
import { DisciplinesPage } from './pages/DisciplinesPage/Disciplines';
import { Test } from './pages/TestPage/Test';
import { useStores } from './custom-hooks/store/use-stores';
import { TestSummary } from './pages/TestSummaryPage/TestSummaryPage';
import { EducationTaskPage } from './pages/EducationTaskPage/EducationTaskPage';
import { ErrorBoundary } from './components/Error/ErrorBoundary';
import { initGlobalErrorHandlers } from './services/GlobalErrorHandler';
import 'dotenv/config';

export const App = observer(() => {
  const {
    userActions: {
      getUserProfile,
    },
    userStore,
    userStore: {
      isAuthenticated,
    },
  } = useStores();

  useEffect(() => {
    initGlobalErrorHandlers();
  }, []);

  useEffect(() => {
    // Public routes that don't require user profile
    const publicRoutes = ['/signup', '/404'];
    const isPublicRoute = publicRoutes.some((route) => window.location.pathname.startsWith(route));

    if (isPublicRoute) {
      // For public routes, set authentication to false immediately
      // This allows the page to render without waiting for profile
      userStore.setUserAuthenticated(false);
    } else {
      // Only fetch user profile if NOT on a public route
      getUserProfile();
    }
  }, [getUserProfile, userStore]);

  if (isAuthenticated === null) {
    return null;
  }

  return (
    <ErrorBoundary>
      <Switch>
        <PrivateRoute exact path="/disciplines" component={() => <DisciplinesPage />} />
        <PrivateRoute path="/test/:testId" component={Test} />
        <Route path="/signup/:assessmentId?" component={SignUpPage} />
        <Route path="/404" component={() => <NotFoundPage />} />
        <Route path="/education/:testId" component={() => <TestSummary />} />
        <Route path="/screening/:testId" component={() => <TestSummary />} />
        <Route path="/education-tasks/:testId" component={() => <EducationTaskPage />} />
        <Redirect from="*" to="/404" />
      </Switch>
    </ErrorBoundary>
  );
});
